<template>
  <div class="classDetail">
    <div class="classDetail-top">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'managementclass' }">
          {{$t('managementV2.myClass')}}
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          {{$t('managementV2.classDetails')}}
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div class="calss-info">
        <div class="info-name"><i></i>{{queryData.name}}</div>
        <ul class="info">
          <li>
            <span
                  class="lable">{{$t('managementV2.major')}}&nbsp;:</span>&nbsp;&nbsp;{{queryData.major||"--"}}
            <i></i>
          </li>
          <li>
            <span
                  class="lable">{{$t('managementV2.member')}}&nbsp;:</span>&nbsp;&nbsp;{{queryData.peopleNum||0}}
            <i></i>
          </li>
          <li>
            <span
                  class="lable">{{$t('managementV2.teacher')}}&nbsp;:</span>&nbsp;&nbsp;{{queryData.creatorName||"--"}}
            <i></i>
          </li>
          <li>
            <span
                  class="lable">{{$t('common.creationTime')}}&nbsp;:</span>&nbsp;&nbsp;{{queryData.createTime||"--"}}
            <i></i>
          </li>
        </ul>
      </div>
    </div>
    <div class="classDetail-table">
      <el-table height="100%" border :data="managementclassList"
                header-row-class-name="customHeader">
        <el-table-column type="index" width="57" :label="$t('managementV2.number')" align="center">
          <template slot-scope="{$index}">
            {{fromateIndex($index)}}
          </template>
        </el-table-column>
        <el-table-column prop="aliasName" :label="$t('jobManagementV2.studentName')" align="center"
                         show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{row.aliasName || '--'}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('managementV2.major')" align="center" show-overflow-tooltip>
          <template slot-scope="{row}">
            {{row.major || '--'}}
          </template>
        </el-table-column>
        <el-table-column prop="email" :label="$t('managementV2.phone')" align="center"
                         show-overflow-tooltip>
          <template slot-scope="{row}">
            {{row.loginPhone || '--'}}
          </template>
        </el-table-column>
        <el-table-column prop="email" :label="$t('managementV2.email')" align="center"
                         show-overflow-tooltip>
          <template slot-scope="{row}">
            {{row.email || '--'}}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background :total="totalRows" @current-change="handleCurrentChange"
                     @size-change="handleSizeChange" :current-page.sync="params.page"
                     :page-size="params.rows" :page-sizes="[10, 20, 30, 40]"
                     layout="prev, pager, next, sizes">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getClassStudentList } from "@/services/managements"
export default {
  name: "myclassDetail",
  data() {
    return {
      managementclassList: [
      ],
      totalRows: 0,
      params: {
        filter: {
          companyCode: "",
          classId: null,
        },
        page: 1,
        rows: 10,
      },
      addstudentVisible: false,
      queryData: {}, //跳转带入的参数
    }
  },
  created() {
    this.queryData = JSON.parse(this.$Base64.decode(this.$route.query.key))
  },
  mounted() {
    this.getClassStudentList();
  },
  computed: {
  },
  methods: {
    fromateIndex(index) {
      if (index < 9) {
        return '0' + (index + 1)
      } else {
        return index + 1
      }
    },
    //获取列表
    async getClassStudentList() {
      this.params.filter.companyCode = this.queryData.companyCode;
      this.params.filter.classId = this.queryData.calassId;
      const { list, success, totalRows } = await getClassStudentList(this.params);
      if (success) {
        this.managementclassList = list;
        this.totalRows = totalRows
      }
    },
    //切换页码
    handleCurrentChange(val) {
      this.params.page = val;
      this.getClassStudentList();
    },
    //切换当前最大条数
    handleSizeChange(newrows) {
      this.params.rows = newrows;
      this.getClassStudentList();
    },
  }
}
</script>
<style lang="less" scoped>
@import "./style.less";
</style>